import { DateRange } from 'react-day-picker'

const isValidDate = (date?: Date) => {
  const isValid = date ? !isNaN(date.getTime()) : false
  if (!isValid) {
    console.warn('In DatePicker invalid date passed to value')
  }
  return isValid
}

const checkArrayDate = (date: Date[]) => {
  const res = date.filter((_date) => isValidDate(_date))
  return res.length ? res : undefined
}

const checkDateRange = (date: DateRange) => {
  return {
    ...date,
    from: isValidDate(date.from) ? date.from : undefined,
    to: isValidDate(date.to) ? date.to : undefined,
  }
}

export const getValidDate = (
  value: Date | DateRange | Date[] | undefined
): Date | DateRange | Date[] | undefined => {
  if (value instanceof Array) {
    return checkArrayDate(value)
  }
  if (value instanceof Date) {
    return isValidDate(value) ? value : undefined
  }
  if (value?.from || value?.to) {
    return checkDateRange(value)
  }
  return value
}
